export default __webpack_public_path__ + "static/media/profile.d05fd6ba.svg";